"use client";
import { jsx as e, jsxs as f } from "react/jsx-runtime";
import { createContext as u, useState as g, useContext as c } from "react";
import b from "../Icon/index.js";
const p = u(), i = ({ children: a, className: o, setIsOpen: s, controlled: t = !1, isOpen: n = !1 }) => {
  const [r, l] = g(n);
  return /* @__PURE__ */ e(p.Provider, { value: { showCollapse: t ? n : r, setShowCollapse: t ? s : l }, children: /* @__PURE__ */ e("div", { className: `sash-Collapse border-b border-b-gray-15 ${o || ""}`, children: a }) });
}, C = ({ className: a, children: o, renderAs: s = "span", activeIcon: t = "remove", inactiveIcon: n = "add", showIcon: r = !0 }) => {
  const { showCollapse: l, setShowCollapse: m } = c(p), h = s, x = () => m(!l);
  return /* @__PURE__ */ f("div", { className: `sash-CollapseItem relative flex items-center px-2 py-4 ${a || ""}`, children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: "sash-CollapseTrigger absolute left-0 top-0 h-full w-full",
        onClick: x,
        "aria-expanded": l,
        "aria-label": l ? "Hide" : "Show"
      }
    ),
    /* @__PURE__ */ e(h, { className: "sash-CollapseText flex-1 font-semibold md:tracking-0.25px", children: o }),
    r && /* @__PURE__ */ e("span", { className: "sash-CollapseIcon ml-4 flex h-[30px] w-[30px] flex-none items-center justify-center text-black", children: /* @__PURE__ */ e(b, { name: l ? t : n }) })
  ] });
}, d = ({ children: a, className: o }) => {
  const { showCollapse: s } = c(p);
  return /* @__PURE__ */ e(
    "div",
    {
      "aria-hidden": s ? "false" : "true",
      className: `sash-CollapseContent px-2 py-4 ${s ? "block" : "hidden"} ${o || ""}`,
      children: a
    }
  );
};
i.Trigger = C;
i.Content = d;
C.displayName = "Collapse.Trigger";
d.displayName = "Collapse.Content";
const T = i;
export {
  T as default
};
